<div class="header__container">
  <div class="header_action-panel__container">
    <div (click)="goHome()" class="header__image">
      <img src="/assets/icons/charge-repay-icon.svg" alt="Charge Repay Logo" />
    </div>
    <div class="header__title__container">
      <div class="header__title__text">Charge Repay Service</div>
      <div class="header__title__info">
        {{ breadcrumbHandler.breadcrumb | translate }}
      </div>
    </div>
  </div>
  @if (authHandler.loggedIn | async) {
    <div class="header_action-container">
      @if (!isOnboarding) {
        <div class="header__info-panel__container">
          <pc-icon
            style="width: 24px; height: 24px; cursor: default"
            [color]="'#343434'"
            [name]="(driverStore.chargePointConnected$ | async) ? 'cloud' : 'cloudOff'"></pc-icon>
        </div>
      }
      <div class="header__menu-container">
        <pc-icon
          class="header__menu-icon"
          [matMenuTriggerFor]="menu"
          name="hamburger"
          color="black"
          data-analytics="analytics-charge-repay-service-driver-view-navigation"></pc-icon>
        <mat-menu #menu="matMenu" xPosition="before">
          <div class="header__menu">
            @if (!isOnboarding) {
              <button mat-menu-item class="header__menu-text" (click)="stateManager.goToCharges()">
                {{ 'CHARGEREPAY_DRIVER.CHARGES' | translate }}
              </button>
              <button mat-menu-item class="header__menu-text" (click)="stateManager.goToAccounting()">
                {{ 'CHARGEREPAY_DRIVER.ACCOUNTING' | translate }}
              </button>
              <button mat-menu-item class="header__menu-text" (click)="stateManager.goToMyWallbox()">
                {{ 'CHARGEREPAY_DRIVER.MY_WALLBOX' | translate }}
              </button>
              <button mat-menu-item class="header__menu-text" (click)="stateManager.goToMileage()">
                {{ 'CHARGEREPAY_DRIVER.MILEAGE2' | translate }}
              </button>
              @if ((driverStore.chargePoint$ | async)?.direct_ocpp) {
                <button mat-menu-item class="header__menu-text" (click)="stateManager.goToManual()">
                  {{ 'CHARGEREPAY_DRIVER.MANUAL' | translate }}
                </button>
              }
              <button mat-menu-item class="header__menu-text" (click)="stateManager.goToSettings()">
                <mat-icon style="color: var(--persian-green)">settings</mat-icon>
                <span> {{ 'CHARGEREPAY_DRIVER.OPTIONS' | translate }}</span>
              </button>
            }
            <button mat-menu-item class="header__menu-text" (click)="stateManager.logout()">
              <mat-icon style="color: var(--persian-green)">logout</mat-icon>
              <span> {{ 'LOGOUT.LOG_OUT' | translate }}</span>
            </button>
          </div>
        </mat-menu>
      </div>
    </div>
  }
</div>
